import { TransactionType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';
import { getSecondaryId } from '../helpers/getSecondaryId';
import { isType } from './isType';

export const isAliasPayTransaction: TransactionPredicate = (transaction) => {
    const isFromInstantPayment = isType(TransactionType.INSTANT_PAYMENT)(transaction);
    const secondaryId = getSecondaryId(transaction);
    const isPaymentViaPhoneNumber = secondaryId?.type === 'PHONE';
    return isFromInstantPayment && isPaymentViaPhoneNumber;
};
